/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./NiceHtml.css'); }
var propTypes = {
    grey: PropTypes.bool,
    lightBlue: PropTypes.bool
};
exports.NiceHtml = function Tag(_a) {
    var children = _a.children, className = _a.className, grey = _a.grey, lightBlue = _a.lightBlue;
    var cssClassNames = ["m-niceHtml", className];
    if (grey) {
        cssClassNames.push("m-niceHtml-isGrey");
    }
    else if (lightBlue) {
        cssClassNames.push("m-niceHtml-isLightBlue");
    }
    return React.createElement("div", { className: classnames(cssClassNames) }, children);
};
exports.NiceHtml.propTypes = propTypes;